import type { Message } from '../fixtures/domain.js';

/** Same window as the backend and chat-js, so both sides of a chat lose Edit at the same moment. */
export const EDIT_WINDOW_MS = 24 * 60 * 60 * 1000;

/** Whether to offer Edit. The backend asks again on save, since the candidate can read it meanwhile. */
export function isEditable(message: Message, currentUserId: string, now = Date.now()): boolean {
  return (
    message.senderId === currentUserId &&
    message.status !== 'sending' &&
    message.status !== 'read' &&
    !message.system &&
    !message.autoReply &&
    isPlainText(message) &&
    now - Date.parse(message.createdAt) < EDIT_WINDOW_MS
  );
}

function isPlainText(message: Message): boolean {
  return (
    !message.attachments?.length &&
    !message.form &&
    !message.formResponse &&
    !message.job &&
    !message.cta
  );
}
